import { AppBadge, AppTooltip } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { INCENTIVE_SALES_STAGE_MAP, OPPORTUNITY_SALES_STAGE_MAP, SALES_STAGE_MAP } from 'shared'

interface SalesStageBadgeProps {
  stageId: number | null
  variant?: 'default' | 'incentive' | 'opportunity'
}

/**
 * SalesStageバッジコンポーネント
 *
 * variantで表示内容を切り替える
 * - default: 通常の売上一覧で使用。基本的なステージ説明のみ表示
 * - incentive: インセンティブ確認画面で使用。係数情報を含むtooltipを表示し、
 *   報酬対象外のステージ(Duplicated, InputError)は除外されたマップを使用
 * - opportunity: オポチュニティ用の売上一覧で使用。
 */
export function SalesStageBadge({ stageId, variant = 'default' }: SalesStageBadgeProps) {
  if (!stageId) return <span className='text-muted-foreground'>ー</span>

  const stageMap = (() => {
    switch (variant) {
      case 'default':
        return SALES_STAGE_MAP
      case 'incentive':
        return INCENTIVE_SALES_STAGE_MAP
      case 'opportunity':
        return OPPORTUNITY_SALES_STAGE_MAP
    }
  })()

  const stage = stageMap[stageId]
  if (!stage) return <span className='text-muted-foreground'>ー</span>

  return (
    <AppTooltip content={<p>{stage.tooltip}</p>}>
      <AppBadge color='secondary' className='cursor-help'>
        {stage.text}
      </AppBadge>
    </AppTooltip>
  )
}
